module.exports = __webpack_public_path__ + "static/media/39.cb1f5d4b.JPG";